import { CreateDelivery } from "../$Delivery"
import { InventoryData, TInventory, TransactionDetail, logisticOptions } from "../../Models/Inventory"
import useService from "../../hooks/useService"
import { createStockTransferOrder } from "../../services/Inventory"
import { TRANSACTION_STATUS } from "../../utils/constant"
import { genId } from "../../utils/helpers"
import Modal, { IModalProps } from "../Modals"
import DynamicForm, { TField, useDynamicForm } from "../forms/DynamicFormNew"


type TInventoryTransfer = {
    logisticAgencyName: string
    awbNumber: string
    remarks: string
}
const INVENTORY_TRANSFER_FORM: TField<TInventoryTransfer>[] = [
    {
        fieldName: 'logisticAgencyName',
        isVisible: true,
        fieldType: 'select',
        label: 'Logistic Agency Name',
        fullWidth: false,
        options: logisticOptions,
        validation: {
            required: true
        }
    },
    {
        fieldName: 'awbNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'AWB Number',
        fullWidth: false,
        validation: {
            required: true
        }
    },
    {
        fieldName: 'remarks',
        isVisible: true,
        fieldType: 'text',
        label: 'Remarks',
        fullWidth: false,
        validation: {
            required: true
        }
    },
]

const DeliveryModal = (props: Omit<IModalProps, 'children' | 'title'>) => {
    const {store:{transactionsStore:{setTransactionInfo}}} = useService()
    return <Modal title="Create Delivery" {...props} fullwidth maxWidth='lg' >
        <CreateDelivery goToNextSection={() => {
            setTransactionInfo(prev => ({...prev, status: TRANSACTION_STATUS.COMPLETED}))
            props.onClose()
            }} />
    </Modal>
}

export default DeliveryModal